import { computed, defineComponent, toRefs } from '@vue/composition-api';
import DpChart from './Chart.vue';
export default defineComponent({
    name: 'DpTimelineStrip',
    components: {
        DpChart,
    },
    props: {
        data: { type: Array, default: () => [] },
        fillInconsistentGaps: { type: Boolean, default: false },
        overlayLine: { type: Boolean, default: false },
    },
    setup(props) {
        const { data, fillInconsistentGaps } = toRefs(props);
        const chartParams = computed(() => {
            const { value } = data;
            if (!value)
                return null;
            let points = value.map(({ date, text, colour }) => ({
                x: date,
                y: 1,
                colour,
                text,
            }));
            // Add manual widths to bars to fill data with inconsitent times
            if (fillInconsistentGaps.value === true) {
                points = points.map((curr, index) => {
                    const next = points[index + 1];
                    if (!next)
                        return curr;
                    const currDate = curr.x;
                    const nextDate = next.x;
                    // Adding an extra 10 seconds to each bar seems to not cause any overlapping and also
                    // fixes any lingering gaps between data
                    const width = nextDate - currDate + 10000;
                    return {
                        ...curr,
                        width,
                    };
                });
            }
            const stripData = {
                values: points,
                hoverinfo: 'x+text',
                type: 'bar',
            };
            const lineData = {
                values: value.map(({ date, text, value: pointValue }) => ({
                    x: date,
                    y: pointValue,
                    text,
                })),
                hoverinfo: 'none',
                type: 'line',
                mode: 'lines',
                yaxis: 'y2',
                color: 'rgba(0, 0, 0, 0.4)',
            };
            const chartData = props.overlayLine ? [stripData, lineData] : [stripData];
            const params = {
                yaxis: {
                    zeroline: false,
                    showline: false,
                    autotick: true,
                    ticks: '',
                    showticklabels: false,
                    range: [0, 1],
                },
                yaxis2: {
                    zeroline: false,
                    showline: false,
                    autotick: true,
                    ticks: '',
                    showticklabels: false,
                    range: [0, 100],
                    type: 'linear',
                },
                xaxis: {
                    type: 'date',
                },
                data: chartData,
                noGaps: true,
            };
            return params;
        });
        return {
            chartParams,
        };
    },
});
